import { useState } from 'react';

import { VStack } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { IServerOrder } from '@rbi-ctg/menu';
import { FavoriteOrderButton } from 'components/favorite-order-button';
import { ItemThumbnailWithBadge } from 'components/item-thumbnail-with-badge/item-thumbnail-with-badge';
import { useOrderDetailsCard } from 'hooks/use-order-details-card';

import { ModalOrderDetails } from './modal-order-details';
import { CardContainer, ItemName, Price, StyledLink } from './styled';

export const OrderDetailsCard = ({ order }: { order: IServerOrder }) => {
  const { formatMessage } = useIntl();
  const { itemHighlighted, totalPrice, totalItems } = useOrderDetailsCard(order);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  return (
    <CardContainer>
      {itemHighlighted && <ItemThumbnailWithBadge item={itemHighlighted} totalItems={totalItems} />}
      <VStack flex={1} marginLeft="$4">
        <Price focusable>{totalPrice}</Price>
        <ItemName numberOfLines={1} focusable>
          {itemHighlighted?.name}
        </ItemName>
        <StyledLink marginTop="$2" onPress={() => setIsDetailsModalOpen(true)}>
          {formatMessage({ id: 'viewDetails' })}
        </StyledLink>
      </VStack>
      <VStack alignSelf="flex-start">
        <FavoriteOrderButton order={order} />
      </VStack>
      <ModalOrderDetails
        serverOrder={order}
        showModal={isDetailsModalOpen}
        onCloseModal={() => setIsDetailsModalOpen(false)}
      />
    </CardContainer>
  );
};
